import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const HomeEdFacilitatorListPage = lazy(() => import('src/pages/home-ed-facilitator/list'));
const HomeEdFacilitatorDetailPage = lazy(() => import('src/pages/home-ed-facilitator/detail'));

// ----------------------------------------------------------------------

const guardedListPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdFacilitatorListPage />
  </RoleBasedGuard>
);

const guardedDetailPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdFacilitatorDetailPage />
  </RoleBasedGuard>
);

export const homeEdFacilitatorRoutes = [
  {
    path: 'home-ed-facilitators',
    children: [
      { element: guardedListPage, index: true },
      { path: ':externalId', element: guardedDetailPage },
    ],
  },
];
